var map = {
	"./OnFocus_Media_reel.mp4": "72f4",
	"./showcase/animacion-2d-3d_reel.mp4": "2b65",
	"./showcase/cine-documental-y-storytelling_reel.mp4": "378c",
	"./showcase/fotografia_reel.mp4": "13ee",
	"./showcase/streaming_reel.mp4": "c283",
	"./showcase/video-corporativo-y-eventos_reel.mp4": "f72b",
	"./showcase/video-y-fotografia-aerea_reel.mp4": "c3fd",
	"./showcase/video-y-fotografia-subacuatica_reel.mp4": "b6eb",
	"./team/sergio.mp4": "2252"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d56";